export const tinyDate = (date) => date ? new Date(date).toLocaleDateString(window.appData.locale, { day: '2-digit', month: '2-digit' }) : '-'

const getColor = (event) => {
  switch (event.type) {
    case 'site_task':
      return '#33CCFF'
    case 'provider_event':
      return '#508fca'
    default:
      return '#000000'
  }
}

export const serializeEvent = (site_task) => ({
  id: site_task.id,
  text: site_task.title,
  start_date: new Date(site_task.start_date),
  end_date: new Date(site_task.end_date),
  color: getColor(site_task),
  percentage_completed: site_task.percentage_completed,
})

export const serializeProviderEvent = (providerEvent) => ({
  id: providerEvent.id,
  text: providerEvent.title,
  start_date: new Date(providerEvent.start_date),
  end_date: new Date(providerEvent.end_date),
  color: getColor({ type: 'provider_event' }),
  type: 'provider_event',
  readonly: true,
})

export const serializeCalendarData = (remoteData) => {
  const siteTasks = remoteData.calendarTasks.map(serializeEvent)
  const projectTaskList = remoteData.projects.map((project) => ({
    id: project.id,
    name: project.title,
    expanded: true,
    sites: project.sites,
    categories: remoteData.taskCategories.map((category) => ({
      id: `${project.id}:${category.id}`,
      name: category.short || category.title,
      expanded: true,
      tasks: remoteData.calendarTasks.filter((site_task) => site_task.project_id == project.id && site_task.category_id == category.id),
    })).filter(f => f.tasks.length > 0),
  })).filter(f => f.categories.length > 0)

  return {
    siteTasks,
    projectTaskList,
  }
}
